import { availabilityIntervalsService } from '@/services/availabilityIntervals.service.js';

const state = {
  getAvailabilityIntervalsOutput: null,
  getAvailabilityIntervalByIdOutput: null,
  createAvailabilityIntervalOutput: null,
  updateAvailabilityIntervalOutput: null,
  deleteAvailabilityIntervalByIdOutput: null,
  generateSlotsOutput: null,
  archiveAvailabilityIntervalByIdOutput: null,
  unarchiveAvailabilityIntervalByIdOutput: null
};

const mutations = {
  setGetAvailabilityIntervalsOutput(state, payload) {
    state.getAvailabilityIntervalsOutput = payload;
  },
  setGetAvailabilityIntervalByIdOutput(state, payload) {
    state.getAvailabilityIntervalByIdOutput = payload;
  },
  setCreateAvailabilityIntervalOutput(state, payload) {
    state.createAvailabilityIntervalOutput = payload;
  },
  setUpdateAvailabilityIntervalOutput(state, payload) {
    state.updateAvailabilityIntervalOutput = payload;
  },
  setDeleteAvailabilityIntervalByIdOutput(state, payload) {
    state.deleteAvailabilityIntervalByIdOutput = payload;
  },
  setGenerateSlotsOutput(state, payload) {
    state.generateSlotsOutput = payload;
  },
  setArchiveAvailabilityIntervalByIdOutput(state, payload) {
    state.archiveAvailabilityIntervalByIdOutput = payload;
  },
  setUnarchiveAvailabilityIntervalByIdOutput(state, payload) {
    state.unarchiveAvailabilityIntervalByIdOutput = payload;
  }
};

const actions = {
  async getAvailabilityIntervals({ commit }, input) {
    try {
      const response = await availabilityIntervalsService.getList(input);
      commit('setGetAvailabilityIntervalsOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching availability intervals list:', error);
      throw error;
    }
  },
  
  async getById({ commit }, id) {
    try {
      const response = await availabilityIntervalsService.getById(id);
      commit('setGetAvailabilityIntervalByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching availability interval by id:', error);
      throw error;
    }
  },
  
  async create({ commit }, data) {
    try {
      const response = await availabilityIntervalsService.create(data);
      commit('setCreateAvailabilityIntervalOutput', response);
      return response;
    } catch (error) {
      console.error('Error creating availability interval:', error);
      throw error;
    }
  },
  
  async update({ commit }, data) {
    try {
      const response = await availabilityIntervalsService.update(data);
      commit('setUpdateAvailabilityIntervalOutput', response);
      return response;
    } catch (error) {
      console.error('Error updating availability interval:', error);
      throw error;
    }
  },
  
  async deleteAvailabilityIntervalById({ commit }, id) {
    try {
      const response = await availabilityIntervalsService.delete(id);
      commit('setDeleteAvailabilityIntervalByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error deleting availability interval:', error);
      throw error;
    }
  },
  
  async generateSlots({ commit }, { id, regenerateExisting = false }) {
    try {
      const response = await availabilityIntervalsService.generateSlots(id, regenerateExisting);
      commit('setGenerateSlotsOutput', response);
      return response;
    } catch (error) {
      console.error('Error generating slots:', error);
      throw error;
    }
  },
  
  async archiveAvailabilityIntervalById({ commit }, id) {
    try {
      const response = await availabilityIntervalsService.archive(id);
      commit('setArchiveAvailabilityIntervalByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error archiving availability interval:', error);
      throw error;
    }
  },
  
  async unarchiveAvailabilityIntervalById({ commit }, id) {
    try {
      const response = await availabilityIntervalsService.unarchive(id);
      commit('setUnarchiveAvailabilityIntervalByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error unarchiving availability interval:', error);
      throw error;
    }
  }
};

const getters = {
  availabilityIntervals: state => state.getAvailabilityIntervalsOutput?.data || [],
  availabilityInterval: state => state.getAvailabilityIntervalByIdOutput || null
};

export const availabilityIntervals = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

